
import breakpointHelper from '@/mixins/breakpoint-helper';
import { EMPLOYMENT_OPTIONS } from '@/utils/pension-calculator-constants';
import FInfoTooltip from '@/components/molecules/tooltips/info-tooltip';
import RetirementCalculatorInput from '@/ui/retirement-calculator/retirement-calculator-input.vue';

export default {
  name: 'AdvancedInputsForm',

  components: {
    FInfoTooltip,
    RetirementCalculatorInput,
  },

  mixins: [breakpointHelper],

  computed: {
    employmentOptions() {
      return Object.entries(this.$t('employment.options')).map(
        this.createOption,
      );
    },

    inflationOptions() {
      return Object.entries(this.$t('inflation.options')).map(
        this.createOption,
      );
    },

    compulsoryProgramEnrollmentOptions() {
      return Object.entries(this.$t('compulsoryProgramEnrollment.options')).map(
        this.createOption,
      );
    },

    isSelfEmployed() {
      return (
        this.$store.state['pension-calculator'].inputs.current_employment ===
        EMPLOYMENT_OPTIONS.selfEmployed
      );
    },
  },

  methods: {
    createOption([value, text]) {
      // The translation key needs to match the value expected by the BE
      return { value, text };
    },
  },
};
